import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "itemLeft", "itemRight", "MediaBody", "MediaLeft", "MediaRight"];
import PropTypes from 'prop-types';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import UIMedia from './UIMedia';
import UIMediaBody from './UIMediaBody';
import UIMediaLeft from './UIMediaLeft';
import UIMediaRight from './UIMediaRight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UIMediaObject(props) {
  const _ref = props,
    {
      children,
      itemLeft,
      itemRight,
      MediaBody,
      MediaLeft,
      MediaRight
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(UIMedia, Object.assign({}, rest, {
    children: [itemLeft ? /*#__PURE__*/_jsx(MediaLeft, {
      children: itemLeft
    }) : null, /*#__PURE__*/_jsx(MediaBody, {
      children: children
    }), itemRight ? /*#__PURE__*/_jsx(MediaRight, {
      children: itemRight
    }) : null]
  }));
}
UIMediaObject.propTypes = Object.assign({}, UIMedia.propTypes, {
  itemLeft: PropTypes.node,
  itemRight: PropTypes.node,
  MediaBody: getComponentPropType(UIMediaBody),
  MediaLeft: getComponentPropType(UIMediaLeft),
  MediaRight: getComponentPropType(UIMediaRight)
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIMediaObject.defaultProps = Object.assign({}, UIMedia.defaultProps, {
  MediaBody: UIMediaBody,
  MediaLeft: UIMediaLeft,
  MediaRight: UIMediaRight
});
UIMediaObject.displayName = 'UIMediaObject';